import React from "react";
import { cn } from "@helpers/utils";

type Props = {
    children?: any;
    className?: string;
    bold?: boolean;
}

const BaseLabel = ({ children, className, bold = false}: Props) => {
    return (
        <div className={cn("label mb-2 text-md text-[#686868]", bold ? "font-semibold" : "font-normal", className)}>
            {children}
        </div>
    );
};

export default BaseLabel;
